module.exports = __webpack_public_path__ + "img/Flunder_6.d9804596.png";